function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import React, { useCallback } from "react";
import { FilterSelector } from "../../atoms";
import { JobListEntry, Section } from "../../molecules";
// @TODO empty state
export function JobsList(param) {
    var jobs = param.jobs, filtersConfig = param.filtersConfig, filters = param.filters, onFiltersChange = param.onFiltersChange, className = param.className, enableLines = param.enableLines;
    var handleFilterChange = useCallback(function(name, value) {
        var next = _objectSpread({}, filters);
        next[name] = value;
        onFiltersChange === null || onFiltersChange === void 0 ? void 0 : onFiltersChange(next);
    }, [
        filters,
        onFiltersChange
    ]);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, !!(filtersConfig === null || filtersConfig === void 0 ? void 0 : filtersConfig.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mb-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-start justify-start -mx-3 -my-2"
    }, filtersConfig.map(function(config) {
        /*#__PURE__*/ return React.createElement(FilterSelector, {
            key: config.name,
            className: "mx-3 my-2",
            name: config.name,
            value: filters === null || filters === void 0 ? void 0 : filters[config.name],
            label: config.label,
            options: config.options,
            onChange: handleFilterChange
        });
    }))), /*#__PURE__*/ React.createElement("div", null, jobs.map(function(job) {
        return /*#__PURE__*/ React.createElement(JobListEntry, _extends({
            key: job.key || job.title
        }, job));
    })));
}

//# sourceMappingURL=JobsList.js.map